import { useCallback } from 'react';
import type { ToastType, ToastEventDetail } from '../types/toast';

export const useToast = () => {
  const addToast = useCallback((message: string, type: ToastType = 'info', duration?: number) => {
    const detail: ToastEventDetail = { message, type };
    if (duration !== undefined) {
      detail.duration = duration;
    }
    const event = new CustomEvent<ToastEventDetail>('toast:add', { detail });
    window.dispatchEvent(event);
  }, []);

  const success = useCallback((message: string, duration?: number) => {
    addToast(message, 'success', duration);
  }, [addToast]);

  const error = useCallback((message: string, duration?: number) => {
    addToast(message, 'error', duration);
  }, [addToast]);

  const warning = useCallback((message: string, duration?: number) => {
    addToast(message, 'warning', duration);
  }, [addToast]);

  const info = useCallback((message: string, duration?: number) => {
    addToast(message, 'info', duration);
  }, [addToast]);

  return {
    addToast,
    success,
    error,
    warning,
    info
  };
};
